(function () {
  "use strict";

  var SELECTOR_SCOPE = ".shopify-section--main-product";
  var variantHtmlCache = new Map();

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return window.CSS.escape(value);
    }

    return String(value).replace(/["\\#.;?+*~':"!^$[\]()=>|/@]/g, "\\$&");
  }

  function deepQuerySelector(root, selector) {
    var element = root.querySelector(selector);

    if (element) {
      return element;
    }

    root.querySelectorAll("template").forEach(function (template) {
      if (!element) {
        element = deepQuerySelector(template.content, selector);
      }
    });

    return element;
  }

  function closestSectionId(element) {
    var section = element.closest(".shopify-section");
    return section && section.id ? section.id.replace("shopify-section-", "") : "";
  }

  function setBusy(form, isBusy) {
    form.querySelectorAll('[type="submit"], button[form="' + cssEscape(form.id) + '"]').forEach(function (button) {
      if (isBusy) {
        button.setAttribute("aria-busy", "true");
      } else {
        button.removeAttribute("aria-busy");
      }
    });
  }

  function showInlineError(anchor, message) {
    if (!anchor) {
      return;
    }

    var oldError = anchor.parentElement && anchor.parentElement.querySelector(".dm-product-error");
    if (oldError) {
      oldError.remove();
    }

    var errorBanner = document.createElement("div");
    errorBanner.className = "banner banner--error dm-product-error";
    errorBanner.setAttribute("role", "alert");
    errorBanner.textContent = message || "Unable to add this item to cart.";
    anchor.before(errorBanner);

    window.setTimeout(function () {
      errorBanner.remove();
    }, 6000);
  }

  function updateCartCount(cart) {
    if (!cart || typeof cart.item_count === "undefined") {
      return;
    }

    document.querySelectorAll(".item_count, [data-cart-count], .cart-count, #CartCount").forEach(function (node) {
      node.textContent = cart.item_count;
      node.classList.toggle("hidden-count", cart.item_count === 0);
    });
  }

  function isProductDebugEnabled() {
    try {
      return Boolean(
        window.WGN_PRODUCT_DEBUG ||
        window.location.search.indexOf("wgn_product_debug=1") !== -1 ||
        (window.localStorage && window.localStorage.getItem("wgnProductDebug") === "1")
      );
    } catch (error) {
      return Boolean(window.WGN_PRODUCT_DEBUG);
    }
  }

  function debugProductFormData(form, formData) {
    if (!isProductDebugEnabled() || !window.console || typeof window.console.log !== "function") {
      return;
    }

    window.console.log("WGN FORM DATA BEFORE SUBMIT", Array.from(formData.entries()), {
      formId: form && form.id ? form.id : null
    });
  }

  function isNetworkError(error) {
    var message = error && error.message ? error.message : "";

    return error && (
      error.name === "TypeError" ||
      /Failed to fetch|NetworkError|Load failed|fetch/i.test(message)
    );
  }

  function submitFormNatively(form) {
    if (!form) {
      return;
    }

    if (window.HTMLFormElement && window.HTMLFormElement.prototype.submit) {
      window.HTMLFormElement.prototype.submit.call(form);
    } else if (typeof form.submit === "function") {
      form.submit();
    }
  }

  function isValidSellingPlanId(value) {
    value = String(value || "").trim();

    return Boolean(value && value !== "0" && value.toLowerCase() !== "once" && /^\d+$/.test(value));
  }

  function productFormScope(form) {
    return (
      (form && form.closest && form.closest(".shopify-section--main-product")) ||
      (form && form.closest && form.closest(".shopify-section")) ||
      (form && form.closest && form.closest("section")) ||
      document
    );
  }

  function productFormHost(form) {
    return (
      (form && form.closest && form.closest("safe-sticky")) ||
      (form && form.closest && form.closest(".product-info")) ||
      productFormScope(form)
    );
  }

  function isInTemplate(element) {
    return Boolean(element && element.closest && element.closest("template"));
  }

  function findBoldWidgetForForm(form) {
    var host = productFormHost(form);
    var scope = productFormScope(form);
    var widgets = Array.from(host.querySelectorAll("[data-bsub-widget]")).filter(function (widget) {
      return !isInTemplate(widget);
    });

    if (!widgets.length && scope !== host) {
      widgets = Array.from(scope.querySelectorAll("[data-bsub-widget]")).filter(function (widget) {
        return !isInTemplate(widget);
      });
    }

    return widgets[0] || null;
  }

  function compactText(element) {
    return element && element.textContent ? element.textContent.replace(/\s+/g, " ").trim() : "";
  }

  function cleanFrequencyLabel(label) {
    return String(label || "")
      .replace(/\s*[\-\(]\s*save\s*\d+%.*/gi, "")
      .replace(/\s*save\s*\d+%.*/gi, "")
      .replace(/\s*[\-\(]\s*\$\d+.*/g, "")
      .replace(/\s+\/\s+delivery.*/i, "")
      .trim();
  }

  function readBoldFrequencyLabel(widget) {
    if (!widget) {
      return "";
    }

    var selectedOption = widget.querySelector("[data-bsub-selling-plan-option]:checked");
    if (selectedOption) {
      var optionContainer = selectedOption.closest("[data-bsub-selling-plan-option], .bsub-widget__option, .bsub-option-container");
      var optionLabel = cleanFrequencyLabel(
        selectedOption.getAttribute("data-bsub-option") ||
        compactText(optionContainer) ||
        compactText(selectedOption.closest("label"))
      );

      if (optionLabel) {
        return optionLabel;
      }
    }

    var selectedPlan = widget.querySelector("[data-bsub-selling-plan-input]:checked");
    var planContainer = selectedPlan && selectedPlan.closest("[data-bsub-selling-plan]");
    var planText = planContainer && (
      planContainer.querySelector(".bsub-widget__text") ||
      planContainer.querySelector(".bsub-widget__main-text") ||
      planContainer.querySelector("label")
    );

    return cleanFrequencyLabel(compactText(planText));
  }

  function readBoldSellingPlanState(widget) {
    if (!widget) {
      return { isSubscription: false, isExplicitOneTime: false, sellingPlanId: "", frequency: "" };
    }

    var checkedGroup = widget.querySelector("[data-bsub-selling-plan-group-input]:checked");

    if (checkedGroup) {
      var groupValue = String(checkedGroup.value || "").trim();
      if (groupValue === "once" || checkedGroup.hasAttribute("data-bsub-purchase-option-one-time")) {
        return { isSubscription: false, isExplicitOneTime: true, sellingPlanId: "", frequency: "" };
      }
    }

    var sellingPlanId = "";
    var hiddenPlan = widget.querySelector("[data-bsub-selling-plan-id-input]");

    if (hiddenPlan && isValidSellingPlanId(hiddenPlan.value)) {
      sellingPlanId = hiddenPlan.value;
    }

    if (!sellingPlanId && checkedGroup) {
      var checkedPlan = widget.querySelector("[data-bsub-selling-plan-input]:checked");
      if (checkedPlan) {
        sellingPlanId = checkedPlan.value || checkedPlan.getAttribute("data-bsub-selling-plan-id") || "";
      }
    }

    return {
      isSubscription: isValidSellingPlanId(sellingPlanId),
      isExplicitOneTime: false,
      sellingPlanId: isValidSellingPlanId(sellingPlanId) ? String(sellingPlanId).trim() : "",
      frequency: readBoldFrequencyLabel(widget)
    };
  }

  function readGenericSellingPlanState(form) {
    var scope = productFormScope(form);
    var checkedPlan = scope.querySelector('input[name="selling_plan"]:checked:not(:disabled)');

    if (checkedPlan && !form.contains(checkedPlan) && isValidSellingPlanId(checkedPlan.value)) {
      return { isSubscription: true, isExplicitOneTime: false, sellingPlanId: String(checkedPlan.value).trim(), frequency: compactText(checkedPlan.closest("label")) };
    }

    var selectedPlan = scope.querySelector('select[name="selling_plan"]:not(:disabled)');
    if (selectedPlan && !form.contains(selectedPlan) && isValidSellingPlanId(selectedPlan.value)) {
      return {
        isSubscription: true,
        isExplicitOneTime: false,
        sellingPlanId: String(selectedPlan.value).trim(),
        frequency: selectedPlan.options[selectedPlan.selectedIndex] ? cleanFrequencyLabel(selectedPlan.options[selectedPlan.selectedIndex].textContent) : ""
      };
    }

    // Removed aggressive hidden input sniffing to prevent stale state retention

    return { isSubscription: false, isExplicitOneTime: false, sellingPlanId: "", frequency: "" };
  }

  function inputsByName(form, name) {
    if (!form) {
      return [];
    }

    return Array.from(form.querySelectorAll("input")).filter(function (input) {
      return input.name === name;
    });
  }

  function syncHiddenFormInput(form, name, value, enabled, bridgeAttr) {
    var inputs = inputsByName(form, name);
    var target = inputs.find(function (input) {
      return input.hasAttribute(bridgeAttr);
    }) || inputs[0];

    if (!enabled) {
      inputs.forEach(function (input) {
        input.value = "";
        input.disabled = true;
      });
      return null;
    }

    if (!target) {
      target = document.createElement("input");
      target.type = "hidden";
      target.name = name;
      target.setAttribute(bridgeAttr, "true");
      form.appendChild(target);
    }

    inputs.forEach(function (input) {
      if (input !== target) {
        input.disabled = true;
      }
    });

    target.type = "hidden";
    target.name = name;
    target.value = value;
    target.disabled = false;
    target.setAttribute(bridgeAttr, "true");

    return target;
  }

  function normalizeProductFormData(form, formData) {
    if (!formData || !form) {
      return formData;
    }

    var boldWidget = (form.closest('.shopify-section') || document).querySelector('[data-bsub-widget]');
    if (boldWidget) {
      var groupRadio = boldWidget.querySelector('input[name="bsub-selling-plan-group"]:checked');
      var oneTimeRadio = boldWidget.querySelector('[data-bsub-purchase-option-one-time]:checked');
      
      if ((groupRadio && groupRadio.value === 'once') || oneTimeRadio) {
        if (typeof formData.delete === 'function') {
          formData.delete('selling_plan');
          formData.delete('properties[_Purchase Type]');
          formData.delete('properties[_Delivery Frequency]');
        }
      }
    }

    var preferredQuantity = form.querySelector(".wgn-hidden-qty-input") ||
      Array.from(form.elements || []).find(function (element) {
        return element.name === "quantity" && !element.disabled;
      });

    if (preferredQuantity && preferredQuantity.value) {
      formData.set("quantity", preferredQuantity.value);
    }

    return formData;
  }

  window.WGN = window.WGN || {};
  window.WGN.syncSellingPlanToProductForm = function (form, options) {
    options = options || {};

    if (!form) {
      return { isSubscription: false, sellingPlanId: "", frequency: "" };
    }

    var boldWidget = findBoldWidgetForForm(form);

    // Bold Subscriptions PRO (V2) app block owns its own name="selling_plan"
    // input: it creates that hidden input at runtime (on handleSelectionChange)
    // and injects it into this /cart/add form. Its widget exposes
    // [data-bsub-selling-plan-group-input] but NOT the legacy
    // [data-bsub-selling-plan-id-input] (it uses hashed group ids). This theme
    // bridge cannot read V2 state, so if it ran it would resolve "one-time" and
    // DISABLE Bold's injected field, stripping the subscription at submit.
    // When we detect the V2 shape, do nothing and let Bold own selling_plan.
    if (boldWidget &&
        boldWidget.querySelector("[data-bsub-selling-plan-group-input]") &&
        !boldWidget.querySelector("[data-bsub-selling-plan-id-input]")) {
      if (isProductDebugEnabled() && window.console && typeof window.console.log === "function") {
        window.console.log("WGN SELLING PLAN SYNC skipped: Bold Pro V2 app block owns selling_plan", {
          source: options.source || "unknown",
          formId: form.id || null
        });
      }
      return { isSubscription: null, sellingPlanId: "", frequency: "", ownedByApp: true };
    }

    var state = readBoldSellingPlanState(boldWidget);

    if (!state.isSubscription && !state.isExplicitOneTime) {
      var genericState = readGenericSellingPlanState(form);
      if (genericState.isSubscription) {
        state = genericState;
      }
    }

    syncHiddenFormInput(form, "selling_plan", state.sellingPlanId, state.isSubscription, "data-wgn-selling-plan-bridge");
    syncHiddenFormInput(form, "properties[_Purchase Type]", "Subscribe & Save", state.isSubscription, "data-wgn-purchase-type-bridge");
    syncHiddenFormInput(form, "properties[_Delivery Frequency]", state.frequency || "Subscription", state.isSubscription, "data-wgn-delivery-frequency-bridge");

    if (isProductDebugEnabled() && window.console && typeof window.console.log === "function") {
      window.console.log("WGN SELLING PLAN SYNC", {
        source: options.source || "unknown",
        formId: form.id || null,
        isSubscription: state.isSubscription,
        sellingPlanId: state.sellingPlanId || null,
        frequency: state.frequency || null
      });
    }

    return state;
  };


  function ajaxCartUrl() {
    return routesRoot() + (routesRoot().endsWith('/') ? '' : '/') + "cart/add.js";
  }

  function cartUrl() {
    return routesRoot() + (routesRoot().endsWith('/') ? '' : '/') + "cart.js";
  }

  function notifyTargetAjaxCart(lineItem, form, cart) {
    // 1. Try Triggering jQuery events (Standard for many older themes)
    if (window.jQuery) {
      window.jQuery(document.body).trigger("afterAddItem.ajaxCart", [lineItem, form]);
      if (cart) {
        window.jQuery(document.body).trigger("afterGetCart.ajaxCart", cart);
      }
      
      // Support for some themes that listen to 'ajaxProduct:added'
      window.jQuery(document.body).trigger('ajaxProduct:added', [lineItem, form]);
    }

    // 2. Try timber/ajaxCart load (Standard for Timber/Slate themes)
    if (window.ajaxCart && typeof window.ajaxCart.load === "function") {
      window.ajaxCart.load();
      return;
    }

    // 3. Update all known cart count elements
    if (cart) {
      updateCartCount(cart);
    }

    // 4. Try showing the built-in theme modal if it exists
    var popup = document.getElementById("modalAddToCart");
    if (popup) {
      var image = popup.querySelector(".popupimage");
      var title = popup.querySelector(".productmsg");

      if (image && lineItem && (lineItem.image || lineItem.featured_image)) {
        image.src = lineItem.image || lineItem.featured_image.url;
      }

      if (title && lineItem && (lineItem.product_title || lineItem.title)) {
        title.textContent = lineItem.product_title || lineItem.title;
      }

      if (window.jQuery && typeof window.jQuery.fn.modal === "function") {
        window.jQuery(popup).modal("show");
      } else {
        // Fallback if jQuery modal is not available but element exists
        popup.classList.add('show');
        popup.style.display = 'block';
        popup.setAttribute('aria-hidden', 'false');
      }
    } else {
       // Final fallback: redirect to cart if no AJAX feedback is available
       // window.location.href = routesRoot() + 'cart';
    }
  }

  function initBundleCards(root) {
    (root || document).querySelectorAll(".dlrs-bundles").forEach(function (wrapper) {
      if (wrapper.dataset.dmBundleBound === "true") {
        return;
      }

      wrapper.dataset.dmBundleBound = "true";

      var form = findNearestProductForm(wrapper);
      if (!form) {
        return;
      }

      var prop = wrapper.querySelector(".dlrs-bundle-prop");
      if (prop && !form.querySelector(".dlrs-bundle-prop")) {
        form.appendChild(prop);
      }

      var qtyInput = findQuantityInputForForm(form, wrapper);
      var cards = Array.from(wrapper.querySelectorAll(".dlrs-card"));
      var radios = Array.from(wrapper.querySelectorAll(".dlrs-card__radio"));

      function selectCard(card, radio) {
        if (!card) {
          return;
        }

        cards.forEach(function (candidate) {
          candidate.classList.remove("is-selected");
          candidate.setAttribute("aria-checked", "false");
        });

        card.classList.add("is-selected");
        card.setAttribute("aria-checked", "true");

        if (radio) {
          radio.checked = true;
        }

        var activeRadio = radio || card.querySelector(".dlrs-card__radio");
        var activeProp = form.querySelector(".dlrs-bundle-prop");

        if (activeProp && activeRadio) {
          activeProp.value = activeRadio.value;
        }

        if (qtyInput && activeRadio) {
          var desired = parseInt(activeRadio.dataset.qty || card.dataset.qty || "1", 10);
          setQuantity(qtyInput, snapQuantity(desired, qtyInput));
        }
      }

      radios.forEach(function (radio) {
        radio.addEventListener("change", function () {
          selectCard(radio.closest(".dlrs-card"), radio);
        });
      });

      cards.forEach(function (card) {
        card.addEventListener("keydown", function (event) {
          if (event.key !== "Enter" && event.key !== " ") {
            return;
          }

          event.preventDefault();
          var radio = card.querySelector(".dlrs-card__radio");
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      });

      selectCard(cards.find(function (card) { return card.classList.contains("is-selected"); }) || cards[0], radios.find(function (radio) { return radio.checked; }) || radios[0]);
    });
  }

  function findNearestProductForm(wrapper) {
    var section = wrapper.closest("section") || wrapper.closest(SELECTOR_SCOPE) || document;
    return section.querySelector('form[action*="/cart/add"]') || wrapper.closest("form") || document.querySelector('form[action*="/cart/add"]');
  }

  function findQuantityInputForForm(form, wrapper) {
    return form.querySelector('input[name="quantity"]') ||
      (wrapper.closest(SELECTOR_SCOPE) || document).querySelector('input[name="quantity"][form="' + cssEscape(form.id) + '"]') ||
      (wrapper.closest(SELECTOR_SCOPE) || document).querySelector('quantity-selector input[name="quantity"]') ||
      document.querySelector('input[name="quantity"][form="' + cssEscape(form.id) + '"]');
  }

  function snapQuantity(value, input) {
    var min = parseInt(input.getAttribute("min") || "1", 10);
    var maxAttr = input.getAttribute("max");
    var max = maxAttr ? parseInt(maxAttr, 10) : null;
    var step = parseInt(input.getAttribute("step") || "1", 10);

    if (!Number.isFinite(step) || step < 1) {
      step = 1;
    }

    var snapped = Math.max(min, value || min);
    snapped = min + Math.floor((snapped - min) / step) * step;

    if (max !== null && Number.isFinite(max)) {
      snapped = Math.min(max, snapped);
    }

    return Math.max(min, snapped);
  }

  function setQuantity(input, value) {
    input.value = value;
    input.style.setProperty("--quantity-input-characters-count", String(value).length + "ch");
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function emitVariantMedia(media, element) {
    if (!media || !media.preview_image || !element) {
      return;
    }

    var image = element.querySelector("img");
    if (!image) {
      return;
    }

    var widths = (element.getAttribute("widths") || "80,160").split(",").map(function (width) {
      return parseInt(width.trim(), 10);
    }).filter(Boolean);

    var url = new URL(media.preview_image.src.indexOf("//") === 0 ? window.location.protocol + media.preview_image.src : media.preview_image.src);
    var srcset = widths.map(function (width) {
      url.searchParams.set("width", String(width));
      return url.toString() + " " + width + "w";
    }).join(", ");

    image.src = url.toString();
    image.srcset = srcset;
    image.alt = media.alt || image.alt || "";
  }

  function openZoom(image, gallery) {
    if (!image) {
      return;
    }

    var modal = document.querySelector(".dm-zoom-modal");
    if (!modal) {
      modal = document.createElement("div");
      modal.className = "dm-zoom-modal";
      modal.hidden = true;
      modal.innerHTML = '<button type="button" class="dm-zoom-modal__close" aria-label="Close">x</button><img alt="">';
      document.body.appendChild(modal);
      modal.addEventListener("click", function (event) {
        if (event.target === modal || event.target.closest(".dm-zoom-modal__close")) {
          modal.hidden = true;
          document.documentElement.style.overflow = "";
        }
      });
    }

    var modalImage = modal.querySelector("img");
    modalImage.src = image.currentSrc || image.src;
    modalImage.srcset = image.srcset || "";
    modalImage.alt = image.alt || "";
    modal.hidden = false;
    document.documentElement.style.overflow = "hidden";

    if (gallery) {
      gallery.dispatchEvent(new CustomEvent("lightbox:opened", { bubbles: true }));
    }
  }

  function defineElement(name, klass, options) {
    if (window.customElements && !window.customElements.get(name)) {
      try {
        window.customElements.define(name, klass, options);
      } catch (error) {
        console.warn("Unable to define " + name, error);
      }
    }
  }

  var PageDots = class extends HTMLElement {
    connectedCallback() {
      this._abortController = new AbortController();
      this.items = Array.from(this.children);
      this.items.forEach((button, index) => {
        button.addEventListener("click", () => this.select(index), { signal: this._abortController.signal });
      });
      this.addEventListener("control:filter", this._filterItems.bind(this), { signal: this._abortController.signal });

      if (this.controlledElement) {
        this.controlledElement.addEventListener("carousel:change", (event) => this.select(event.detail.index, false), { signal: this._abortController.signal });
      }
    }

    disconnectedCallback() {
      if (this._abortController) {
        this._abortController.abort();
      }
    }

    get controlledElement() {
      return this.hasAttribute("aria-controls") ? document.getElementById(this.getAttribute("aria-controls")) : null;
    }

    select(selectedIndex, dispatchEvent) {
      dispatchEvent = dispatchEvent !== false;
      var visibleItems = this.items.filter(function (item) { return !item.hidden; });
      var selectedItem = this.items[selectedIndex] || visibleItems[selectedIndex];

      if (!selectedItem) {
        return;
      }

      this.items.forEach(function (button) {
        button.setAttribute("aria-current", button === selectedItem ? "true" : "false");
      });

      if (dispatchEvent && this.controlledElement && typeof this.controlledElement.select === "function") {
        this.controlledElement.select(this.items.indexOf(selectedItem));
      }
    }

    _filterItems(event) {
      var filteredIndexes = event.detail.filteredIndexes || [];
      this.items.forEach(function (item, index) {
        item.hidden = filteredIndexes.indexOf(index) !== -1;
      });
    }
  };

  var ScrollCarousel = class extends HTMLElement {
    connectedCallback() {
      this._abortController = new AbortController();
      this.addEventListener("carousel:filter", this._onFilter.bind(this), { signal: this._abortController.signal });
      this.addEventListener("scroll", this._onScroll.bind(this), { passive: true, signal: this._abortController.signal });
      var initialIndex = parseInt(this.getAttribute("initial-index") || "0", 10);
      window.requestAnimationFrame(() => this.select(initialIndex, { animate: false }));
    }

    disconnectedCallback() {
      if (this._abortController) {
        this._abortController.abort();
      }
    }

    get items() {
      return Array.from(this.children);
    }

    get visibleItems() {
      return this.items.filter(function (item) { return !item.hidden; });
    }

    get selectedSlide() {
      return this.visibleItems.find(function (item) { return item.classList.contains("is-selected"); }) || this.visibleItems[0];
    }

    select(index, options) {
      options = options || {};
      var slide = this.items[index] || this.visibleItems[index];

      if (!slide || slide.hidden) {
        slide = this.visibleItems[0];
      }

      if (!slide) {
        return;
      }

      this.items.forEach(function (item) {
        item.classList.toggle("is-selected", item === slide);
      });

      var selectedIndex = this.items.indexOf(slide);

      if (this.scrollWidth > this.clientWidth) {
        this.scrollTo({
          left: slide.offsetLeft - this.offsetLeft,
          behavior: options.animate === false ? "auto" : "smooth"
        });
      }

      this.dispatchEvent(new CustomEvent("carousel:change", {
        bubbles: true,
        detail: { index: selectedIndex, slide: slide }
      }));

      this.dispatchEvent(new CustomEvent("carousel:settle", {
        bubbles: true,
        detail: { index: selectedIndex, slide: slide }
      }));
    }

    next() {
      var visible = this.visibleItems;
      var index = visible.indexOf(this.selectedSlide);
      this.select(this.items.indexOf(visible[Math.min(index + 1, visible.length - 1)]));
    }

    previous() {
      var visible = this.visibleItems;
      var index = visible.indexOf(this.selectedSlide);
      this.select(this.items.indexOf(visible[Math.max(index - 1, 0)]));
    }

    _onFilter(event) {
      var filteredIndexes = event.detail.filteredIndexes || [];
      this.items.forEach(function (item, index) {
        item.hidden = filteredIndexes.indexOf(index) !== -1;
      });
      this.select(this.items.indexOf(this.visibleItems[0]), { animate: false });
    }

    _onScroll() {
      window.clearTimeout(this._scrollTimer);
      this._scrollTimer = window.setTimeout(() => {
        if (!this.visibleItems.length) {
          return;
        }

        var closest = this.visibleItems.reduce((winner, item) => {
          var distance = Math.abs(item.offsetLeft - this.scrollLeft);
          var winnerDistance = Math.abs(winner.offsetLeft - this.scrollLeft);
          return distance < winnerDistance ? item : winner;
        }, this.visibleItems[0]);

        this.items.forEach(function (item) {
          item.classList.toggle("is-selected", item === closest);
        });

        this.dispatchEvent(new CustomEvent("carousel:change", {
          bubbles: true,
          detail: { index: this.items.indexOf(closest), slide: closest }
        }));
      }, 80);
    }
  };

  var MediaCarousel = class extends ScrollCarousel {
    connectedCallback() {
      super.connectedCallback();
      this.addEventListener("click", this._onGalleryClick.bind(this));
      this.addEventListener("carousel:settle", this._onMediaSettled.bind(this));
    }

    _onGalleryClick(event) {
      if (event.target.closest("button, a, input, label") || !window.matchMedia("(pointer: fine)").matches) {
        return;
      }

      if (!this.selectedSlide || this.selectedSlide.getAttribute("data-media-type") !== "image") {
        return;
      }

      var rect = this.getBoundingClientRect();
      if (event.clientX - rect.left > rect.width / 2) {
        this.next();
      } else {
        this.previous();
      }
    }

    _onMediaSettled(event) {
      this.items.forEach(function (item) {
        if (item !== event.detail.slide && item.firstElementChild && typeof item.firstElementChild.pause === "function") {
          item.firstElementChild.pause();
        }
      });

      if (this.hasAttribute("autoplay") && event.detail.slide && event.detail.slide.firstElementChild && typeof event.detail.slide.firstElementChild.play === "function") {
        event.detail.slide.firstElementChild.play();
      }
    }
  };

  var ProductGallery = class extends HTMLElement {
    connectedCallback() {
      this._abortController = new AbortController();
      this._carousels = Array.from(this.querySelectorAll("media-carousel"));
      this._pageDots = Array.from(this.querySelectorAll("page-dots"));
      this._viewInSpaceButton = this.querySelector("[data-shopify-xr]");
      this._customCursor = this.querySelector(".product-gallery__cursor");
      var form = document.forms[this.getAttribute("form")];

      if (form) {
        form.addEventListener("product:rerender", this._onSectionRerender.bind(this), { signal: this._abortController.signal });
        form.addEventListener("variant:change", this._onVariantChanged.bind(this), { signal: this._abortController.signal });
      }

      this.addEventListener("carousel:change", this._onCarouselChanged.bind(this), { signal: this._abortController.signal });
      this.addEventListener("click", this._onZoomClicked.bind(this), { signal: this._abortController.signal });
    }

    disconnectedCallback() {
      if (this._abortController) {
        this._abortController.abort();
      }
    }

    get filteredIndexes() {
      try {
        return JSON.parse(this.getAttribute("filtered-indexes") || "[]").map(function (index) {
          return parseInt(index, 10) - 1;
        });
      } catch (error) {
        return [];
      }
    }

    _onZoomClicked(event) {
      var zoomButton = event.target.closest('[is="product-zoom-button"], .product-gallery__zoom button');
      if (!zoomButton || !this.hasAttribute("allow-zoom")) {
        return;
      }

      event.preventDefault();
      var media = zoomButton.closest(".product-gallery__media") || (this.querySelector("media-carousel") && this.querySelector("media-carousel").selectedSlide);
      var image = media && media.querySelector("img");
      openZoom(image, this);
    }

    _onCarouselChanged(event) {
      if (this._customCursor) {
        this._customCursor.toggleAttribute("hidden", event.detail.slide.getAttribute("data-media-type") !== "image");
      }

      if (this._viewInSpaceButton && event.detail.slide.getAttribute("data-media-type") === "model") {
        this._viewInSpaceButton.setAttribute("data-shopify-model3d-id", event.detail.slide.getAttribute("data-media-id"));
      }
    }

    _onVariantChanged(event) {
      var variant = event.detail.variant;

      if (!variant || !variant.featured_media) {
        return;
      }

      var newMediaPosition = variant.featured_media.position ? variant.featured_media.position - 1 : undefined;
      if (newMediaPosition !== undefined) {
        this._carousels.forEach(function (carousel) {
          carousel.select(newMediaPosition, { animate: false });
        });
      }
    }

    _onSectionRerender(event) {
      var galleryMarkup = deepQuerySelector(event.detail.htmlFragment, this.tagName.toLowerCase() + '[form="' + this.getAttribute("form") + '"]');
      if (!galleryMarkup) {
        return;
      }

      var oldIndexes = this.filteredIndexes.join(",");
      this.setAttribute("filtered-indexes", galleryMarkup.getAttribute("filtered-indexes") || "[]");
      var newIndexes = this.filteredIndexes;

      if (oldIndexes !== newIndexes.join(",")) {
        this._carousels.forEach(function (carousel) {
          carousel.dispatchEvent(new CustomEvent("carousel:filter", { detail: { filteredIndexes: newIndexes } }));
        });
        this._pageDots.forEach(function (pageDots) {
          pageDots.dispatchEvent(new CustomEvent("control:filter", { detail: { filteredIndexes: newIndexes } }));
        });
      }
    }
  };

  var ProductZoomButton = class extends HTMLButtonElement {
    constructor() {
      super();
      this.addEventListener("click", function () {});
    }
  };

  var QuantitySelector = class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.dmQuantityBound === "true") {
        return;
      }

      this.dataset.dmQuantityBound = "true";
      this.inputElement = this.querySelector("input");
      var buttons = this.querySelectorAll("button");

      if (buttons[0]) {
        buttons[0].addEventListener("click", this.stepDown.bind(this));
      }

      if (buttons[1]) {
        buttons[1].addEventListener("click", this.stepUp.bind(this));
      }
    }

    stepDown() {
      if (!this.inputElement) {
        return;
      }

      this.inputElement.stepDown();
      this.inputElement.dispatchEvent(new Event("change", { bubbles: true }));
    }

    stepUp() {
      if (!this.inputElement) {
        return;
      }

      this.inputElement.stepUp();
      this.inputElement.dispatchEvent(new Event("change", { bubbles: true }));
    }
  };

  var QuantityInput = class extends HTMLInputElement {
    constructor() {
      super();
      this.addEventListener("input", this._onValueInput.bind(this));
      this.addEventListener("change", this._onValueChanged.bind(this));
      this.addEventListener("focus", this.select.bind(this));
    }

    get quantity() {
      return parseInt(this.value, 10);
    }

    set quantity(quantity) {
      if (quantity === "") {
        return;
      }

      var parsed = parseInt(quantity, 10);
      if (!Number.isFinite(parsed) || parsed < 0) {
        parsed = parseInt(this.min || "1", 10);
      }

      setQuantity(this, snapQuantity(parsed, this));
    }

    _onValueInput() {
      this.quantity = this.value;
    }

    _onValueChanged() {
      if (this.value === "") {
        this.quantity = this.min || 1;
      } else if (!this.checkValidity()) {
        this.quantity = this.value;
      }
    }
  };

  var ProductForm = class extends HTMLFormElement {
    constructor() {
      super();
      this._submitting = false;
      this.addEventListener("submit", this._onSubmit.bind(this), true);
    }

    connectedCallback() {
      var idInput = this.querySelector('[name="id"]');
      if (idInput) {
        idInput.disabled = false;
      }
    }

    async _onSubmit(event) {
      if (!window.fetch || !window.FormData) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (this._submitting) {
        return;
      }

      if (!this.checkValidity()) {
        this.reportValidity();
        return;
      }

      var idInput = this.querySelector('[name="id"]');
      if (!idInput || !idInput.value) {
        showInlineError(this.querySelector("buy-buttons") || this, "Please select an available option.");
        return;
      }

      setBusy(this, true);
      this._submitting = true;

      try {
        if (window.WGN && typeof window.WGN.syncSellingPlanToProductForm === "function") {
          window.WGN.syncSellingPlanToProductForm(this, { source: "product-form-submit" });
        }

        var formData = normalizeProductFormData(this, new FormData(this));
        debugProductFormData(this, formData);

        var response = await fetch(routesRoot() + "cart/add.js", {
          method: "POST",
          body: formData,
          headers: { "X-Requested-With": "XMLHttpRequest" }
        });
        var responseJson = await response.json();

        if (!response.ok) {
          throw new Error(responseJson.description || responseJson.message || "Unable to add this item to cart.");
        }

        var cart = await fetch(routesRoot() + "cart.js", { headers: { "X-Requested-With": "XMLHttpRequest" } }).then(function (cartResponse) {
          return cartResponse.json();
        }).catch(function () {
          return null;
        });

        notifyTargetAjaxCart(responseJson, this, cart);
        this.dispatchEvent(new CustomEvent("variant:add", {
          bubbles: true,
          detail: { items: responseJson.items || [responseJson], cart: cart || {} }
        }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: { baseEvent: "variant:add", cart: cart || {} }
        }));
      } catch (error) {
        if (isNetworkError(error)) {
          submitFormNatively(this);
          return;
        }

        showInlineError(this.querySelector("buy-buttons") || this, error.message);
        this.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: { error: error.message }
        }));

        var errorPopup = document.getElementById("modalAddToCartError");
        if (errorPopup && window.jQuery && typeof window.jQuery.fn.modal === "function") {
          var message = errorPopup.querySelector(".error_message");
          if (message) {
            message.textContent = error.message;
          }
          window.jQuery(errorPopup).modal("show");
        }
      } finally {
        this._submitting = false;
        setBusy(this, false);
      }
    }
  };

  var BuyButtons = class extends HTMLElement {
    connectedCallback() {
      this._productForm = document.forms[this.getAttribute("form")];
      this._onCartErrorListener = this._onCartError.bind(this);
      if (this._productForm) {
        this._productForm.addEventListener("cart:error", this._onCartErrorListener);
      }
    }

    disconnectedCallback() {
      if (this._productForm) {
        this._productForm.removeEventListener("cart:error", this._onCartErrorListener);
      }
    }

    _onCartError(event) {
      showInlineError(this, event.detail.error);
    }
  };

  var ProductRerender = class extends HTMLElement {
    connectedCallback() {
      this._abortController = new AbortController();
      
      const initialize = () => {
        var form = document.forms[this.getAttribute("observe-form")] || document.getElementById(this.getAttribute("observe-form"));

        if (!this.id || !form) {
          if (!this.id) return;
          setTimeout(initialize, 100);
          return;
        }

        form.addEventListener("product:rerender", this._onRerender.bind(this), { signal: this._abortController.signal });
      };

      initialize();
    }

    disconnectedCallback() {
      if (this._abortController) {
        this._abortController.abort();
      }
    }

    _onRerender(event) {
      var matchingElement = deepQuerySelector(event.detail.htmlFragment, "#" + cssEscape(this.id));
      if (!matchingElement) {
        return;
      }

      if (!this.hasAttribute("allow-partial-rerender") || event.detail.productChange) {
        this.replaceWith(matchingElement);
        initMigratedProduct(matchingElement);
        return;
      }

      var focusedId = document.activeElement && document.activeElement.id;
      var blockTypes = [
        "sku",
        "badges",
        "price",
        "payment-terms",
        "variant-picker",
        "bundle-card-block",
        "quantity-selector",
        "delivery-info",
        "volume-pricing",
        "inventory",
        "buy-buttons",
        "pickup-availability",
        "pdp-payment-row",
        "pdp-usps",
        "liquid"
      ];

      blockTypes.forEach((blockType) => {
        this.querySelectorAll('[data-block-type="' + blockType + '"]').forEach((element) => {
          var matchingBlock = matchingElement.querySelector('[data-block-type="' + blockType + '"][data-block-id="' + element.getAttribute("data-block-id") + '"]');

          if (!matchingBlock) {
            return;
          }

          matchingBlock.querySelectorAll("noscript").forEach(function (noscript) {
            noscript.remove();
          });

          if (blockType === "buy-buttons" && element.querySelector("buy-buttons") && matchingBlock.querySelector("buy-buttons")) {
            element.querySelector("buy-buttons").replaceWith(matchingBlock.querySelector("buy-buttons"));
          } else if (blockType === "quantity-selector") {
            var existingQuantity = element.querySelector('input[name="quantity"]') && element.querySelector('input[name="quantity"]').value;
            element.replaceWith(matchingBlock);
            var newInput = matchingBlock.querySelector('input[name="quantity"]');
            if (newInput && existingQuantity) {
              setQuantity(newInput, snapQuantity(parseInt(existingQuantity, 10), newInput));
            }
          } else {
            element.replaceWith(matchingBlock);
          }
        });
      });

      if (focusedId) {
        var focusedElement = document.getElementById(focusedId);
        if (focusedElement && this.contains(focusedElement)) {
          focusedElement.focus();
        }
      }

      initMigratedProduct(this);
      if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === "function") {
        window.Shopify.PaymentButton.init();
      }
    }
  };

  var VariantPicker = class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.dmVariantBound === "true") {
        return;
      }

      this.dataset.dmVariantBound = "true";
      this._selectedVariant = this._readVariant();
      
      const initialize = () => {
        this._form = document.forms[this.getAttribute("form-id")] || document.getElementById(this.getAttribute("form-id"));

        if (!this._form) {
          // If form not found, try again in next tick
          setTimeout(initialize, 100);
          return;
        }

        this._onChange = this._onOptionChanged.bind(this);
        this._onPreload = this._onOptionPreload.bind(this);
        this._form.addEventListener("change", this._onChange);
        this._form.addEventListener("pointerenter", this._onPreload, true);
        this._form.addEventListener("touchstart", this._onPreload, true);

        var idInput = this._form.querySelector('[name="id"]');
        if (idInput && this._selectedVariant && this._selectedVariant.id) {
          idInput.value = this._selectedVariant.id;
          idInput.disabled = false;
        }
      };

      initialize();
    }

    disconnectedCallback() {
      if (this._form) {
        this._form.removeEventListener("change", this._onChange);
        this._form.removeEventListener("pointerenter", this._onPreload, true);
        this._form.removeEventListener("touchstart", this._onPreload, true);
      }
    }

    get selectedVariant() {
      return this._selectedVariant;
    }

    get productHandle() {
      return this.getAttribute("handle");
    }

    get updateUrl() {
      return this.hasAttribute("update-url");
    }

    async selectCombination(options) {
      var previousVariant = this._selectedVariant || null;
      var htmlText = await this._renderForCombination(options.optionValues, options.productUrl);
      var newContent = document.createRange().createContextualFragment(htmlText);

      if (!options.productChange) {
        var newVariantPicker = deepQuerySelector(newContent, 'variant-picker[form-id="' + this.getAttribute("form-id") + '"]');
        var newVariant = newVariantPicker ? JSON.parse(newVariantPicker.querySelector("script[data-variant]")?.textContent || "{}") : {};
        this._selectedVariant = newVariant;

        var idInput = this._form.querySelector('[name="id"]');
        if (idInput) {
          idInput.value = newVariant && newVariant.id ? newVariant.id : "";
          idInput.dispatchEvent(new Event("change", { bubbles: true }));
        }

        if (this.updateUrl && newVariant && newVariant.id) {
          var newUrl = new URL(window.location.href);
          newUrl.searchParams.set("variant", newVariant.id);
          window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
        }
      }

      this._form.dispatchEvent(new CustomEvent("product:rerender", {
        detail: { htmlFragment: newContent, productChange: !!options.productChange }
      }));

      if (!options.productChange) {
        this._form.dispatchEvent(new CustomEvent("variant:change", {
          bubbles: true,
          detail: {
            formId: this._form.id,
            variant: this._selectedVariant,
            previousVariant: previousVariant
          }
        }));
      }

      if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === "function") {
        window.Shopify.PaymentButton.init();
      }
    }

    _readVariant() {
      try {
        return JSON.parse(this.querySelector("script[data-variant]")?.textContent || "{}");
      } catch (error) {
        return {};
      }
    }

    _getActiveOptionValues() {
      return Array.from(this._form.elements).filter(function (item) {
        return item.matches && item.matches("input[data-option-position]:checked");
      }).sort(function (a, b) {
        return parseInt(a.getAttribute("data-option-position"), 10) - parseInt(b.getAttribute("data-option-position"), 10);
      }).map(function (input) {
        return input.value;
      });
    }

    _getOptionValuesFromInput(input) {
      return [input].concat(Array.from(this._form.elements).filter(function (item) {
        return item.matches && item.matches('input[data-option-position]:not([name="' + cssEscape(input.name) + '"]):checked');
      })).sort(function (a, b) {
        return parseInt(a.getAttribute("data-option-position"), 10) - parseInt(b.getAttribute("data-option-position"), 10);
      }).map(function (item) {
        return item.value;
      });
    }

    _onOptionChanged(event) {
      if (!event.target.matches || !event.target.matches("input[data-option-position]")) {
        return;
      }

      this.selectCombination({
        optionValues: this._getActiveOptionValues(),
        productChange: event.target.hasAttribute("data-product-url"),
        productUrl: event.target.dataset.productUrl
      }).catch(function (error) {
        if (isProductDebugEnabled() && window.console && typeof window.console.warn === "function") {
          console.warn("Variant update failed", error);
        }
      });
    }

    _onOptionPreload(event) {
      var input = event.target && event.target.control ? event.target.control : event.target;
      if (!input || !input.matches || !input.matches("input[data-option-position]:not(:checked)")) {
        return;
      }

      this._renderForCombination(this._getOptionValuesFromInput(input), input.dataset.productUrl).catch(function () {});
    }

    async _renderForCombination(optionValues, productUrl) {
      var optionValuesAsString = optionValues.join(",");
      var cacheKey = [this.getAttribute("section-id"), optionValuesAsString, productUrl || ""].join("|");

      if (!variantHtmlCache.has(cacheKey)) {
        var resolvedProductUrl = productUrl || (routesRoot() + "products/" + this.productHandle);
        var sectionParam = this.getAttribute("context") === "quick_buy" ? "" : "&section_id=" + encodeURIComponent(this.getAttribute("section-id") || closestSectionId(this));
        var requestUrl = resolvedProductUrl + "?option_values=" + encodeURIComponent(optionValuesAsString) + sectionParam;

        variantHtmlCache.set(cacheKey, fetch(requestUrl, {
          headers: { "X-Requested-With": "XMLHttpRequest" }
        }).then(function (response) {
          if (!response.ok) {
            throw new Error("Unable to fetch selected variant.");
          }
          return response.text();
        }));

        if (variantHtmlCache.size > 100) {
          variantHtmlCache.delete(variantHtmlCache.keys().next().value);
        }
      }

      return variantHtmlCache.get(cacheKey);
    }
  };

  var VariantMedia = class extends HTMLElement {
    connectedCallback() {
      this._form = document.forms[this.getAttribute("form")];
      this._onVariantChanged = this._onChange.bind(this);
      if (this._form) {
        this._form.addEventListener("variant:change", this._onVariantChanged);
      }
    }

    disconnectedCallback() {
      if (this._form) {
        this._form.removeEventListener("variant:change", this._onVariantChanged);
      }
    }

    _onChange(event) {
      if (event.detail.variant && event.detail.variant.featured_media) {
        emitVariantMedia(event.detail.variant.featured_media, this);
      }
    }
  };

  var GiftCardRecipient = class extends HTMLElement {
    connectedCallback() {
      this._checkbox = this.querySelector('[name="properties[__shopify_send_gift_card_to_recipient]"]');
      this._fields = this.querySelector(".gift-card-recipient__fields");
      this._offset = this.querySelector('[name="properties[__shopify_offset]"]');
      this._otherProperties = Array.from(this.querySelectorAll('[name*="properties"]')).filter((input) => input !== this._checkbox);

      if (this._offset) {
        this._offset.value = new Date().getTimezoneOffset().toString();
      }

      if (this._checkbox) {
        this._checkbox.addEventListener("change", this._sync.bind(this));
      }

      this._sync();
    }

    _sync() {
      var checked = !!(this._checkbox && this._checkbox.checked);
      this._otherProperties.forEach(function (property) {
        property.disabled = !checked;
      });

      if (this._fields) {
        this._fields.hidden = !checked;
      }
    }
  };

  var XPopover = class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute("open")) {
        this.hidden = true;
      }
    }

    show(control) {
      this.hidden = false;
      this.setAttribute("open", "");
      if (control) {
        control.setAttribute("aria-expanded", "true");
      }
    }

    hide() {
      this.hidden = true;
      this.removeAttribute("open");
      document.querySelectorAll('[aria-controls="' + cssEscape(this.id) + '"]').forEach(function (control) {
        control.setAttribute("aria-expanded", "false");
      });
    }

    toggle(control) {
      if (this.hidden) {
        this.show(control);
      } else {
        this.hide();
      }
    }
  };

  var XDrawer = class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.dmDrawerReady === "true") {
        return;
      }

      this.dataset.dmDrawerReady = "true";
      this.hidden = true;
      this.classList.add("dm-drawer");
      var panel = document.createElement("div");
      panel.className = "dm-drawer__panel";
      var close = document.createElement("button");
      close.type = "button";
      close.className = "dm-drawer__close";
      close.setAttribute("aria-label", "Close");
      close.textContent = "x";
      close.addEventListener("click", this.hide.bind(this));
      panel.appendChild(close);

      while (this.firstChild) {
        panel.appendChild(this.firstChild);
      }

      this.appendChild(panel);
      this.addEventListener("click", (event) => {
        if (event.target === this) {
          this.hide();
        }
      });
    }

    show() {
      this.hidden = false;
      document.documentElement.style.overflow = "hidden";
      document.querySelectorAll('[aria-controls="' + cssEscape(this.id) + '"]').forEach(function (control) {
        control.setAttribute("aria-expanded", "true");
      });
      return Promise.resolve();
    }

    hide() {
      this.hidden = true;
      document.documentElement.style.overflow = "";
      document.querySelectorAll('[aria-controls="' + cssEscape(this.id) + '"]').forEach(function (control) {
        control.setAttribute("aria-expanded", "false");
      });
      return Promise.resolve();
    }

    toggle() {
      return this.hidden ? this.show() : this.hide();
    }
  };

  var QuickBuyDrawer = class extends XDrawer {
    async show() {
      if (!this._hasLoaded && this.getAttribute("handle")) {
        var response = await fetch(routesRoot() + "products/" + this.getAttribute("handle"));
        var html = await response.text();
        var template = new DOMParser().parseFromString(html, "text/html").getElementById("quick-buy-content");

        if (template) {
          var panel = this.querySelector(".dm-drawer__panel");
          panel.querySelectorAll(":scope > :not(.dm-drawer__close)").forEach(function (node) {
            node.remove();
          });
          panel.appendChild(template.content.cloneNode(true));
          initMigratedProduct(panel);
          if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === "function") {
            window.Shopify.PaymentButton.init();
          }
        }

        this._hasLoaded = true;
      }

      return super.show();
    }
  };

  var ProductQuickAdd = class extends HTMLElement {
    connectedCallback() {
      this._scopeFrom = document.getElementById(this.getAttribute("form"));
      this._scopeTo = document.querySelector(".footer, footer");

      if (!this._scopeFrom || !("IntersectionObserver" in window)) {
        return;
      }

      this._scopeFromPassed = false;
      this._scopeToReached = false;
      this._observer = new IntersectionObserver(this._onObserved.bind(this));
      this._observer.observe(this._scopeFrom);

      if (this._scopeTo) {
        this._observer.observe(this._scopeTo);
      }
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
      }
    }

    _onObserved(entries) {
      entries.forEach((entry) => {
        if (entry.target === this._scopeFrom) {
          this._scopeFromPassed = entry.boundingClientRect.bottom < 0;
        }

        if (entry.target === this._scopeTo) {
          this._scopeToReached = entry.isIntersecting;
        }
      });

      this.classList.toggle("is-visible", this._scopeFromPassed && !this._scopeToReached);
    }
  };

  var ProductRecommendations = class extends HTMLElement {
    async connectedCallback() {
      if (this.dataset.dmRecommendationsLoaded === "true" || !this.getAttribute("product")) {
        return;
      }

      this.dataset.dmRecommendationsLoaded = "true";
      var sectionId = closestSectionId(this);
      if (!sectionId) {
        return;
      }

      var url = routesRoot() + "recommendations/products?section_id=" + encodeURIComponent(sectionId) +
        "&product_id=" + encodeURIComponent(this.getAttribute("product")) +
        "&limit=" + encodeURIComponent(this.getAttribute("limit") || "4") +
        "&intent=" + encodeURIComponent(this.getAttribute("intent") || "complementary");

      try {
        var html = await fetch(url).then(function (response) { return response.text(); });
        var matching = new DOMParser().parseFromString(html, "text/html").querySelector('product-recommendations[product="' + this.getAttribute("product") + '"]');
        if (matching && matching.innerHTML.trim()) {
          this.innerHTML = matching.innerHTML;
          initMigratedProduct(this);
        }
      } catch (error) {
        this.hidden = true;
      }
    }
  };

  var VideoMedia = class extends HTMLElement {
    connectedCallback() {
      var video = this.querySelector("video");
      var template = this.querySelector("template");
      var preview = this.querySelector("img");

      if (video) {
        if (preview) {
          preview.hidden = true;
        }
        return;
      }

      if (template && !this.querySelector("iframe")) {
        this.addEventListener("click", () => {
          if (!this.querySelector("iframe")) {
            this.appendChild(template.content.cloneNode(true));
            if (preview) {
              preview.hidden = true;
            }
          }
        }, { once: true });
      }
    }

    play() {
      var media = this.querySelector("video, iframe");
      if (media && typeof media.play === "function") {
        media.play();
      }
    }

    pause() {
      var media = this.querySelector("video");
      if (media && typeof media.pause === "function") {
        media.pause();
      }
    }
  };

  var ModelMedia = class extends HTMLElement {
    play() {}
    pause() {}
  };

  var AccordionDisclosure = class extends HTMLDetailsElement {
    constructor() {
      super();
      this.addEventListener("toggle", () => {
        this.setAttribute("aria-expanded", this.open ? "true" : "false");
      });
    }
  };

  var CustomButton = class extends HTMLButtonElement {};
  var CloseButton = class extends HTMLButtonElement {
    constructor() {
      super();
      this.addEventListener("click", function () {
        var controlled = this.closest("x-drawer, quick-buy-drawer, x-popover");
        if (controlled && typeof controlled.hide === "function") {
          controlled.hide();
        }
      });
    }
  };
  var ShareButton = class extends HTMLButtonElement {
    constructor() {
      super();
      this.addEventListener("click", async () => {
        if (navigator.share) {
          await navigator.share({ title: document.title, url: window.location.href }).catch(function () {});
        }
      });
    }
  };
  var PrevButton = class extends HTMLButtonElement {
    constructor() {
      super();
      this.addEventListener("click", () => {
        var carousel = document.getElementById(this.getAttribute("aria-controls"));
        if (carousel && typeof carousel.previous === "function") {
          carousel.previous();
        }
      });
    }
  };
  var NextButton = class extends HTMLButtonElement {
    constructor() {
      super();
      this.addEventListener("click", () => {
        var carousel = document.getElementById(this.getAttribute("aria-controls"));
        if (carousel && typeof carousel.next === "function") {
          carousel.next();
        }
      });
    }
  };

  class NoopElement extends HTMLElement {}

  function initMigratedProduct(root) {
    initBundleCards(root || document);
  }

  defineElement("page-dots", PageDots);
  defineElement("scroll-carousel", ScrollCarousel);
  defineElement("media-carousel", MediaCarousel);
  defineElement("scroll-shadow", NoopElement);
  defineElement("safe-sticky", NoopElement);
  defineElement("custom-cursor", NoopElement);
  defineElement("product-gallery", ProductGallery);
  defineElement("product-zoom-button", ProductZoomButton, { extends: "button" });
  defineElement("quantity-selector", QuantitySelector);
  defineElement("quantity-input", QuantityInput, { extends: "input" });
  defineElement("product-form", ProductForm, { extends: "form" });
  defineElement("buy-buttons", BuyButtons);
  defineElement("product-rerender", ProductRerender);
  defineElement("variant-picker", VariantPicker);
  defineElement("variant-media", VariantMedia);
  defineElement("variant-inventory", NoopElement);
  defineElement("variant-sku", NoopElement);
  defineElement("payment-terms", NoopElement);
  defineElement("gift-card-recipient", GiftCardRecipient);
  defineElement("pickup-availability", NoopElement);
  defineElement("product-quick-add", ProductQuickAdd);
  defineElement("product-recommendations", ProductRecommendations);
  defineElement("x-popover", XPopover);
  defineElement("x-drawer", XDrawer);
  defineElement("quick-buy-drawer", QuickBuyDrawer);
  defineElement("model-media", ModelMedia);
  defineElement("video-media", VideoMedia);
  defineElement("price-list", NoopElement);
  defineElement("sale-price", NoopElement);
  defineElement("compare-at-price", NoopElement);
  defineElement("unit-price", NoopElement);
  defineElement("on-sale-badge", NoopElement);
  defineElement("sold-out-badge", NoopElement);
  defineElement("accordion-disclosure", AccordionDisclosure, { extends: "details" });
  defineElement("custom-button", CustomButton, { extends: "button" });
  defineElement("close-button", CloseButton, { extends: "button" });
  defineElement("share-button", ShareButton, { extends: "button" });
  defineElement("prev-button", PrevButton, { extends: "button" });
  defineElement("next-button", NextButton, { extends: "button" });

  document.addEventListener("click", function (event) {
    var control = event.target.closest("[aria-controls]");
    if (!control) {
      document.querySelectorAll("x-popover[open]").forEach(function (popover) {
        if (!popover.contains(event.target)) {
          popover.hide();
        }
      });
      return;
    }

    var controlled = document.getElementById(control.getAttribute("aria-controls"));
    if (!controlled) {
      return;
    }

    if (controlled.matches("x-popover, x-drawer, quick-buy-drawer")) {
      event.preventDefault();
      controlled.toggle(control);
    }
  });

  document.addEventListener("change", function (event) {
    if (event.target.matches("x-popover input[type='radio'], x-popover input[type='checkbox']")) {
      var popover = event.target.closest("x-popover");
      if (popover) {
        popover.hide();
      }
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initMigratedProduct(document);
    });
  } else {
    initMigratedProduct(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initMigratedProduct(event.target);
  });

  document.addEventListener("shopify:block:select", function (event) {
    var block = event.target;
    if (block && block.scrollIntoView) {
      block.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  });

  document.addEventListener("shopify:block:deselect", function () {});
})();
